import axios from "axios";

import { baseUrl } from "./baseUrl";
import { uploadImage, updateImage } from './imageApiV2';

const api = axios.create({
    baseURL: `${baseUrl}/admin/user`,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});

export const createBadgeCategory = async (data) => {
    try {
        // Upload image to Image API V2 if file provided
        if (data.file && data.file instanceof File) {
            console.log('📤 Uploading badge category image to Image API V2...');
            const imageResult = await uploadImage(data.file, 'badges', false);

            // Send imageUrl to backend
            data.imageUrl = imageResult.url;
            delete data.file; // Remove file from payload

            console.log('✅ Badge category image uploaded:', imageResult);
        } else if (data.file && typeof data.file === 'string') {
            // If file is a string (existing URL), convert to imageUrl
            data.imageUrl = data.file;
            delete data.file;
        }

        const res = await api.post("/add-badge-cat", data);
        return res.data;
    } catch (error) {
        console.error("Error creating badge:", error);
        throw error;
    }
}

export const getBadgeCategoryList = async () => {
    try {
        const res = await api.get("/list-cat");
        return res.data.data;
    } catch (error) {
        console.error("Error fetching BadgeCategoryList:", error);
        throw error;
    }
}

export const getBadgeCategoryById = async (id) => {
    try {
        const res = await api.get(`/view-cat?id=${id}`);
        return res.data.data;
    } catch (error) {
        console.error("Error fetching BadgeCategory by ID:", error);
        throw error;
    }
}

export const updateBadgeCategory = async (data) => {
    try {
        // Upload image to Image API V2 if new file provided
        if (data.file && data.file instanceof File) {
            console.log('📤 Uploading new badge category image to Image API V2...');
            const imageResult = await uploadImage(data.file, 'badges', false);

            // Send imageUrl to backend
            data.imageUrl = imageResult.url;
            delete data.file; // Remove file from payload

            console.log('✅ Badge category image uploaded:', imageResult);
        } else if (data.file && typeof data.file === 'string') {
            // If file is a string (existing URL), convert to imageUrl
            data.imageUrl = data.file;
            delete data.file;
        }

        const res = await api.put("/update-cat", data);
        return res.data;
    } catch (error) {
        console.error("Error updating badgeCategory:", error);
        throw error;
    }
}

export const deleteBadgeCategory = async (id) => {
    try {
        const res = await api.delete(`/delete-cat?id=${id}`);
        return res.data;
    } catch (error) {
        console.error("Error deleting fact:", error);
        throw error;
    }
}

export const createBadge = async (data) => {
    try {
        // Upload image to Image API V2 if file provided
        if (data.file && data.file instanceof File) {
            console.log('📤 Uploading badge image to Image API V2...');
            const imageResult = await uploadImage(data.file, 'badges', false);

            // Send imageUrl to backend
            data.imageUrl = imageResult.url;
            delete data.file; // Remove file from payload

            console.log('✅ Badge image uploaded:', imageResult);
        } else if (data.file && typeof data.file === 'string') {
            // If file is a string (existing URL), convert to imageUrl
            data.imageUrl = data.file;
            delete data.file;
        }

        const res = await api.post("/add-badge", data);
        return res.data;
    } catch (error) {
        console.error("Error creating tip:", error);
        throw error;
    }
}

export const getBadgeList = async () => {
    try {
        const res = await api.get("/list-badge");
        return res.data;
    } catch (error) {
        console.error("Error fetching BadgeList:", error);
        throw error;
    }
}

export const getBadgeById = async (id) => {
    try {
        const res = await api.get(`view-badge/${id}`);
        return res.data;
    } catch (error) {
        console.error(`Error fetching tip with ID ${id}:`, error);
        throw error;
    }
}

export const updateBadge = async (data) => {
    try {
        // Upload image to Image API V2 if new file provided
        if (data.file && data.file instanceof File) {
            console.log('📤 Uploading new badge image to Image API V2...');
            const imageResult = await uploadImage(data.file, 'badges', false);

            // Send imageUrl to backend
            data.imageUrl = imageResult.url;
            delete data.file; // Remove file from payload

            console.log('✅ Badge image uploaded:', imageResult);
        } else if (data.file && typeof data.file === 'string') {
            // If file is a string (existing URL), convert to imageUrl
            data.imageUrl = data.file;
            delete data.file;
        }

        const res = await api.put(`/update-badge`, data);
        return res.data;
    } catch (error) {
        console.error(`Error updating badge `, error);
        throw error;
    }
}

export const deleteBadge = async (id) => {
    try {
        const res = await api.delete(`/delete-badge/${id}`);
        return res.data;
    } catch (error) {
        console.error("Error deleting badge:", error);
        throw error;
    }
}

export const assignBadgeToUser = async (data) => {
    try {
        const res = await api.post("/assign-badge", data);
        return res.data;
    } catch (error) {
        console.error("Error assigning badge to user:", error);
        throw error;
    }
}